// extracted by mini-css-extract-plugin
export default {"subscription_item_price":"EA","delete_item":"FA","subscription_item":"GA","subscription_item_img_wrapper":"HA","subscription_item_info":"IA","subscription_item_title":"JA","subscription_item_edit":"KA","subscription_item_wrapper":"LA","arrow":"MA","subscription_item_category":"NA","plus_button":"OA","more_details":"PA","old_price":"QA","discount":"RA"};
    if(module.hot) {
      // 1715276856501
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  